import { showToast } from "utils/swalToast"

//config para traer la url
import config from "config"

async function fetchPost(data) {
  let url = `${config.api.baseURL}/usuarios`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  //const elem = document.getElementById("formAddUs");
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: ` Bearer ${token}`,
    },
  })
    .then((r) => {
      if (r.ok) {
        // La respuesta es exitosa (200 OK) pero sin contenido, así que devolvemos solo el estado
        return { status: r.status, body: null }
      } else {
        // Si hay un error, lanzamos una excepción para manejarlo en el bloque .catch
        return r.json().then((data) => {
          throw new Error(data.error || "Error desconocido")
        })
      }
    })
    .then((response) => {
      const elem = document.getElementById("formAddUs")
      if (response.status === 200) {
        if (elem) {
          elem.reset()
        }
        showToast({
          title: "Creado exitosamente",
          icon: "success",
        })
        return response.body
      }
    })
    .catch((error) => {
      showToast({
        icon: "info",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchUserById(id) {
  let url = `${config.api.baseURL}/usuarios/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener los datos del usuario")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function updateUser(id, data) {
  let url = `${config.api.baseURL}/usuarios/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => {
          showToast({
            icon: "error",
            title: "Error al actualizar",
            text: error.message || "No se pudo actualizar el usuario",
          })
          throw new Error(error.message || "No se pudo actualizar el usuario")
        })
      } else {
        return response.json()
      }
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchRoles() {
  let url = `${config.api.baseURL}/roles`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener los roles")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchEmpre() {
  let url = `${config.api.baseURL}/empresas`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener las empresas")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchSucursales(optionEmpresa) {
  if (optionEmpresa) {
    let url = `${config.api.baseURL}/sucursales/empresa/${optionEmpresa}`
    const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (!response.ok) {
        throw new Error("Error al obtener las sucursales")
      }
      return await response.json()
    } catch (error) {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    }
  }
}

async function fetchEventos(optionEmpresa) {
  if (optionEmpresa) {
    let url = `${config.api.baseURL}/eventos/empresa/${optionEmpresa}`
    const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (!response.ok) {
        throw new Error("Error al obtener las sucursales")
      }
      return await response.json()
    } catch (error) {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    }
  }
}

async function fetchSucursalesByEmpresas(empresaIds) {
  const listas = await Promise.all(empresaIds.map((idEmpresa) => fetchSucursales(idEmpresa)))
  return listas.flatMap((lista) => lista || [])
}

async function fetchEventosByEmpresas(empresaIds) {
  const listas = await Promise.all(empresaIds.map((idEmpresa) => fetchEventos(idEmpresa)))
  return listas.flatMap((lista) => lista || [])
}

async function fetchCurrentRoles(id) {
  let url = `${config.api.baseURL}/usuarios/${id}/roles`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener rol asignado")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchCurrentEmpresas(id) {
  let url = `${config.api.baseURL}/usuarios/${id}/empresas`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener la empresa asignada")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchCurrentSucursal(id) {
  let url = `${config.api.baseURL}/usuarios/${id}/sucursales`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener la empresa asignada")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchCurrentEvento(id) {
  let url = `${config.api.baseURL}/usuarios/${id}/eventos`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error("Error al obtener la empresa asignada")
    }
    return await response.json()
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function fetchUserToken(id) {
  let url = `${config.api.baseURL}/usuarios/${id}/token`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.status === 404 || response.status === 204) {
      return { token: "" }
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => null)
      throw new Error(errorData?.message || "Error al obtener token del usuario")
    }

    const data = await response.json().catch(() => ({}))
    return { token: data?.token || "" }
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

async function generateUserToken(id) {
  let url = `${config.api.baseURL}/usuarios/${id}/generate-token`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  try {
    const request = (method) =>
      fetch(url, {
        method,
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

    let response = await request("POST")
    if (response.status === 405) {
      response = await request("GET")
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => null)
      throw new Error(errorData?.message || "No se pudo generar el token")
    }

    const data = await response.json()
    if (!data?.token) {
      throw new Error("La respuesta no contiene token")
    }

    return data
  } catch (error) {
    showToast({
      icon: "error",
      title: "Error",
      text: error.message,
    })
    throw error
  }
}

export { fetchRoles, fetchEmpre, fetchSucursales, fetchEventos, fetchSucursalesByEmpresas, fetchEventosByEmpresas }

export { updateUser }

export { fetchCurrentRoles }

export { fetchCurrentEmpresas, fetchCurrentSucursal, fetchCurrentEvento }

export { fetchUserById }

export { fetchPost }

export { fetchUserToken }

export { generateUserToken }
